import { IDictionary, MLHelper } from '@bimser/core';
import { IFindMessagePub } from '../entities';
import { getMessages } from '../helper/getMessages';

const findMessage = (function () {
	const messages: IDictionary<IDictionary<string>> = getMessages();
	const pub: IFindMessagePub = {};
	let locale = localStorage.locale?.replace(/-/g, '_') || localStorage.defaultLanguage;
	let defaultCulture = localStorage.defaultLanguage?.replace(/-/g, '_') || 'en_US';
	const availableCultures = Object.keys(messages);

	let defaultCultureMessages = messages[defaultCulture] || {};

	pub.get = (id, culture) => {
		if (!culture) {
			culture = locale;
		}
		if (culture) {
			culture = culture.replace(/-/g, '_');
		}
		if (!id) {
			return '0';
		}

		const cultureMessages = messages[culture] || {};

		const word = cultureMessages[id] || defaultCultureMessages[id];

		if (!word) {
			const firstAvailableCulture = availableCultures[0];
			if (firstAvailableCulture) {
				return messages[firstAvailableCulture][id] || id;
			} else {
				return id;
			}
		}

		return word;
	};

	pub.getAsMultiLanguageObject = (id: string, replacer?: (mlText: string) => string) => {
		const result: IDictionary<string> = {};
		MLHelper.supportedLanguages?.forEach(i => {
			const mlText = findMessage.get(id, i.culture);
			result[i.culture] = replacer ? replacer(mlText) : mlText;
		});
		return result;
	};

	pub.updateCulture = (_locale?: string, _defaultCulture?: string) => {
		if (_locale) {
			locale = _locale.replace(/-/g, '_');
		}
		if (_defaultCulture) {
			defaultCulture = _defaultCulture.replace(/-/g, '_');
			defaultCultureMessages = messages[defaultCulture];
		}
	};

	return pub;
})();

export default findMessage;
